module.exports = __webpack_public_path__ + "static/vegepygmy_with_thorny-055cc60a6532605d056b3d14e4d47064.jpeg";